window.addEventListener("DOMContentLoaded", () => {
  const registerForm = document.querySelector(".webinars .register-form");

  if (!registerForm) return;

  const scrollToForm = (e) => {
    const watchNowBtn = e.target.closest(".js-watch-now-btn");
    if (!watchNowBtn) {
      return;
    }
    const header = document.querySelector(".site-header.sticky");
    const headerHeight = header ? header.offsetHeight : 0;
    const top =
      registerForm.getBoundingClientRect().top + window.scrollY - headerHeight;

    window.scrollTo({ top, behavior: "smooth" });
  };

  document.addEventListener("click", scrollToForm);

  const container = document.querySelector(".register-cta__content");
  const badge = document.getElementById("countdown-badge");

  if (!container || !badge) return;

  const calcTimeUntilEvent = () => {
    const eventUTC = new Date(container.dataset.eventUtc).getTime();
    const durationMs = parseInt(container.dataset.eventDuration) * 60000;
    const eventEndUTC = eventUTC + durationMs;
    let intervalId;

    const text = document.getElementById("countdown-text");

    const updateTime = () => {
      const now = Date.now();
      const diff = eventUTC - now;

      if (now >= eventUTC && now < eventEndUTC) {
        badge.className = "countdown-badge live";
        text.textContent = "LIVE NOW";
        return;
      }

      if (now >= eventEndUTC) {
        badge.className = "countdown-badge ended";
        text.textContent = "Event Ended";
        clearInterval(intervalId);
        return;
      }

      const days = Math.floor(diff / 86400000);
      const hours = Math.floor((diff % 86400000) / 3600000);
      const minutes = Math.floor((diff % 3600000) / 60000);
      const seconds = Math.floor((diff % 60000) / 1000);
      const pad = (n) => String(n).padStart(2, "0");

      badge.className  = 'countdown-badge';
      if (days > 0) {
        text.textContent = `${pad(days)}d : ${pad(hours)}h : ${pad(minutes)}m : ${pad(seconds)}s`;
      } else {
        if (diff < 3_600_000) {
          badge.className += ' soon';
        }
        text.textContent = `${pad(hours)}h : ${pad(minutes)}m : ${pad(seconds)}s`;
      }
    };
    intervalId = setInterval(updateTime, 1000);
    updateTime();
  };

  calcTimeUntilEvent();
});
